import * as R from 'ramda';
import { requestWithAuthorization } from './requestWithAuthorization';
import portalConfigure from '@/portal-configure';
import { globalSnackbarModule } from '@/store/modules/GlobalSnackbarStore';
import { ErrorInfo } from '@/types/type';

export const startUserDeletionWorkflow = async (
  tenant: string,
  landscape: string,
  loginName: string
): Promise<string> => {
  const response = await requestWithAuthorization
    .post(`${portalConfigure.API.startUserDeletionWorkflow}`, {
      tenant,
      landscape,
      loginName,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00012',
          title: 'Failed to start user deletion workflow',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });
  globalSnackbarModule.storeExecutionArnAction(response.data);
  return response.data;
};
